<template>
    <div class="page what-we-do">

        <home-skeleton v-if="loading" style="margin-top: 30px"></home-skeleton>

        <div v-else>
            <div class="home-container">

                <div class="swipe">
                    <van-swipe :autoplay="3000" indicator-color="#fff" touchable ref="swipe">
                        <van-swipe-item v-for="(item,i) in banners" :key="i">
                            <a @click="clickBanner">
                                <img :src="item.img" alt="">
                            </a>
                        </van-swipe-item>
                    </van-swipe>
                </div>

                <div class="home-section">
                    <div class="home-section-box" v-for="(item,i) in recommend" :key="item.id">

                        <div v-if="item.content_type === 2" class="article-list-section" style="padding-bottom: 0">
                            <van-row class="article-list-section-box" @click="go_article_detail(item)">
                                <van-col span="8">
                                    <van-image
                                        fit="cover"
                                        class="article-list-content-img"
                                        :src="item.cover_img"
                                        width="100%"
                                        height="74"
                                    />
                                    <div class="article-list-section-left-zl" v-if="item.type == 2">
                                        图文专题
                                    </div>
                                    <div class="article-list-section-left-zl" v-else>
                                        精彩图文
                                    </div>
                                </van-col>
                                <van-col span="16" class="article-list-content">
                                    <div class="article-list-title">{{item.title}}</div>
                                    <div class="article-list-content-detail">
                                        <div>{{item.created_at.substring(0,10)}}<span style="margin-left: 8px">{{item.view_count}}人阅读</span></div>
                                    </div>
                                </van-col>
                            </van-row>
                        </div>

                        <div class="live-list-section" v-if="item.content_type === 4" style="padding-bottom: 0">
                            <van-row @click="go_live_detail(item)">
                                <div class="live-list-section-box" style="padding-bottom: 0">
                                    <div class="live-list-section-left">
                                        <img class="live-list-section-left-img" :src="item.cover_img">
                                        <div v-if="item.type==2" class="live-list-section-left-zl">直播专题</div>
                                        <div v-else-if="item.live_status==0" class="live-list-section-left-zl">直播预告</div>
                                        <div v-else-if="item.live_status==1" class="live-list-section-left-zl">
                                            <img src="/static/bytx/activity_list_live_icon.gif" alt=""> 直播中
                                        </div>
                                        <div v-else class="live-list-section-left-zl">
                                            直播回放
                                        </div>
                                        <div class="live-list-section-left-time" v-if="item.live_status>1"><span>{{item.duration_format}}</span></div>
                                    </div>
                                    <div class="live-list-section-right">
                                        <div class="live-list-section-right-title" v-html="item.title"></div>
                                        <div class="live-list-section-right-detail" style="bottom: 0">
                                            <span v-if="item.type === 2">共{{item.total_count}}期</span>
                                            <span v-else-if="item.live_status < 2">{{item.start_at.substring(0,16)}}</span>
                                            <span v-else>{{item.view_count}}人观看</span>
                                            <span class="live-list-section-right-detail-join" v-if="item.type != 2 && item.live_status < 2">
                                                <span>{{item.live_status === 0 ? item.isAppointment ? '已预约':'预约' : '加入'}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </van-row>
                        </div>

                        <div v-if="item.content_type === 12" class="article-list-section" style="padding-bottom: 0">
                            <van-row class="article-list-section-box" @click="linkTo(item)">
                                <van-col span="8">
                                    <van-image
                                        fit="cover"
                                        class="article-list-content-img"
                                        :src="item.cover_img"
                                        width="100%"
                                        height="74"
                                    />
                                </van-col>
                                <van-col span="16" class="article-list-content">
                                    <div class="article-list-title">{{item.title}}</div>
                                    <div class="article-list-content-detail">
                                        <div>{{item.created_at.substring(0,10)}}<span style="margin-left: 8px">{{item.view_count}}人阅读</span></div>
                                    </div>
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div class="pre-page">
            <img src="/static/bytx/public/welfare_back_btn.svg" @click="$router.push({name:'welfare-zone'})">
        </div>
    </div>
</template>

<script>

    import Interface from "@/util/interface"
    import homeSkeleton from "@/skeleton/homeSkeleton"
    import {LocationHref} from '@/util/common'

    export default {
        name: 'home',
        components :{
            'home-skeleton' : homeSkeleton
        },
        data() {
            return {
                //问医生
                appid:"gh_2af07dce0869",
                //doctor_path:"",
                doctor_path:"pages/doctorModule/doctorList/index.html?routerName=expertList",
                value: "",
                banners:[],
                recommend:[],
                articles:[],
                active:0,
                loading :true,
                page:1,
                pageSize:10,
                total_page:1,
                swiperOption:{
                    width:192,
                    height:249,
                    spaceBetween:15,
                },
                record_id: 0
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'homepage') {

                    let params = {
                        pageSize : 100,
                    }

                    Interface.getData('get',Interface.community.what_we_do,params).then((res)=>{
                        // this.banners = res.data.banners
                        this.recommend = res.data.list
                        setTimeout(()=>{this.loading = false;},500)
                    })
                }else if (scene === 'banner'){
                    Interface.getData('get',Interface.banner,{type:8}).then((res)=>{
                        this.banners = res.data
                    })
                }
            },
            go_live_detail(item) {
                Interface.footPrint(44,item.id,0,item.title)
                Interface.getData("get",Interface.public.content_record+item.id)
                if (item.type === 2) {
                    this.$router.push({'name': 'live-column', params: {id: item.content_id}})
                } else if (item.live_status === 6) {
                    this.$router.push({'name': 'live-detail-home', params: {id: item.content_id}})
                } else {
                    if (item.live_status === 0) {
                        this.$router.push({'name': 'live-detail', params: {id: item.content_id}})
                    } else {
                        this.$router.push({'name': 'live-detail-home', params: {id: item.content_id}})
                    }
                }
            },
            go_video_detail(item){
                Interface.footPrint(44,item.id,0,item.title)
                if (item.content_type === 2) {
                    this.$router.push({'name': 'video-column', params: {id: item.id}})
                } else {
                    this.$router.push({'name': 'video-detail', params: {id: item.id}})
                }
            },
            go_article_detail(item){
                Interface.footPrint(44,item.id,0,item.title)
                Interface.getData("get",Interface.public.content_record+item.id)
                if (item.type === 2) {
                    this.$router.push({'name': 'article-column', params: {id: item.content_id}})
                } else {
                    this.$router.push({'name': 'article-detail', params: {id: item.content_id}})
                }
            },
            toDoctor(){
                Interface.footPrint(18,0,0,"点击首页金刚区按钮 问医生")

                LocationHref("https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=expert")
            },
            goList(name,remark,id){
                Interface.footPrint(18,id,0,"点击首页金刚区按钮 "+remark)

                this.$router.push({
                    'name':name
                })
            },
            goGuide(){
                Interface.footPrint(18,4,0,"点击首页金刚区按钮 ")
                this.$router.push({path:"/guide-category/0"})
            },
            linkTo(item){
                Interface.footPrint(44,item.id,0,item.title)
                Interface.getData("get",Interface.public.content_record+item.id).then(()=>{
                    LocationHref(item.target_url)
                })
            },
            clickBanner(item){
                if (item.target_url!=""){
                    LocationHref(item.target_url.replace('https://care-yyh.com','https://care-yyh.com'))
                }
            }
        },
        created() {
            // Interface.listShareInfo(this,3)
            this.fetch('homepage')
            this.fetch('banner')
            sessionStorage.removeItem("search_data")
            Interface.getData('post',Interface.footprint, {
              id: 0,
              type: 57,
              content_type: 0,
              page_type: 6,
              source_type: 0,
              parent_id: 0,
              record_id: 0,
              title: '公益行动列表'
            }).then( (res) => {
              if (res.code == 0) {
                this.record_id = res.data.record_id
              }
            })
        },
        beforeRouteLeave(to, from, next) {
          if (this.record_id) {
            Interface.mFootPrint(0, 57,0, 6, 0, 0,this.record_id,'公益行动列表')
          }
          next()
        }
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/community/what-we-do/index.vue